{
  "label": "Benutzer",
  "button": {
    "delete": "Benutzer entfernen",
    "create": "Neuer Benutzer",
    "activate": "Den Benutzer aktivieren",
    "deactivate": "Den Benutzer deaktivieren",
    "disabled": {
      "unauthorized": "Unzureichende Berechtigungen, um diesen Benutzer zu bearbeiten"
    }
  },
  "empty": "Keine Benutzer gefunden",
  "confirmRemove": {
    "title": "Benutzerentfernung",
    "description": "Der ausgewählte Benutzer „{userName} {userFirstname}“ wird entfernt."
  },
  "form": {
    "userIdentity": {
      "title": "Information"
    },
    "userProfile": {
      "title": "Profil"
    },
    "userGroups": {
      "title": "Gruppen",
      "selectAllLabel": "Alle Gruppen auswählen"
    },
    "tabs": {
      "information": "Information",
      "delegations": "Delegationen"
    },
    "delegations": {
      "selectOrganization": "Die Organisation auswählen",
      "selectProfile": "Das Profil auswählen",
      "noProfile": "Kein Profil"
    }
  },
  "search": "Nach Vornamen oder Nachnamen suchen",
  "userAccount": {
    "userInformations": {
      "title": "Benutzerinformationen"
    },
    "password": {
      "title": "Passwort"
    },
    "language": {
      "title": "Sprache",
      "activeDirectoryWarning": "Sprachänderung ist nicht möglich, wenn Active Directory aktiviert ist."
    },
    "certificate": {
      "title": "Zertifikat"
    },
    "instructions": {
      "informations": "Aktualisieren Sie hier Ihre persönlichen Daten.",
      "email": "Verwalten Sie Ihre E-Mail-Adresse.",
      "phone": "Fügen Sie Ihre Telefonnummer hinzu.",
      "password": "Ändern Sie Ihr Passwort.",
      "language": "Wählen Sie die Sprache, in der Sie LX CONNECT verwenden möchten."
    },
    "forms": {
      "cancel": "Abbrechen",
      "certificateEmpty": "Kein Zertifikat verfügbar",
      "certificateStatusDateFormat": "YYYY-MM-DD",
      "currentPassword": "Aktuelles Passwort bestätigen",
      "edit": "Bearbeiten",
      "email": "E-Mail-Adresse",
      "firstName": "Vorname",
      "generatedOn": "Generiert am",
      "lastName": "Nachname",
      "login": "Benutzername",
      "newPassword": "Neues Passwort",
      "organisationName": "Organisationsname",
      "phoneNumber": "Telefonnummer",
      "profile": "Profil",
      "requestNewCertificate": "Ein neues Zertifikat anfordern",
      "sectors": "Sektoren",
      "validate": "Bestätigen",
      "validFrom": "Gültig ab",
      "validTo": "Gültig bis"
    }
  },
  "table": {
    "column": {
      "lastName": "Nachname",
      "firstName": "Vorname",
      "profile": "Profil",
      "email": "E-Mail-Adresse",
      "groups": "Gruppen",
      "status": "Status"
    }
  },
  "status": {
    "active": "Aktiv",
    "inactive": "Inaktiv"
  },
  "firstNameRequiredError": "Der Vorname ist erforderlich.",
  "lastNameRequiredError": "Der Nachname ist erforderlich.",
  "loginRequiredError": "Der Benutzername ist erforderlich.",
  "emailRequiredError": "Die E-Mail-Adresse ist erforderlich.",
  "languageError": "Die Sprache ist erforderlich.",
  "firstNameLengthError": "Länge zwischen 1 und 50 Zeichen.",
  "firstNameFormatError": "Sonderzeichen sind außer am Anfang oder am Ende erlaubt --> [ -_.'].",
  "lastNameLengthError": "Länge zwischen 1 und 50 Zeichen.",
  "lastNameFormatError": "Sonderzeichen sind außer am Anfang oder am Ende erlaubt --> [ -_.'].",
  "loginLengthError": "Länge zwischen 3 und 50 Zeichen.",
  "loginFormatError": "Nur Kleinbuchstaben. Sonderzeichen sind zulässig, außer am Anfang oder am Ende --> [!$%&'*+=?^`{'{'}{'|'}{'}'}~{'@'}_.-].",
  "emailFormatError": "Ungültiges E-Mail-Format.",
  "create": {
    "title": "Benutzererstellung",
    "information": "Information",
    "saveButton": "Den Benutzer erstellen",
    "confirm": {
      "title": "Benutzererstellung"
    }
  },
  "lastName": "Nachname",
  "firstName": "Vorname",
  "addUser": {
    "button": "Neuer Benutzer"
  },
  "login": "Benutzername",
  "email": "E-Mail-Adresse",
  "language": "Sprache",
  "profile": "Profil",
  "profilePlaceholder": "Nach dem Namen des Profils suchen",
  "profileRequired": "Das Profil ist erforderlich.",
  "groups": "Gruppen",
  "groupsSearchPlaceholder": "Nach Gruppennamen suchen",
  "sectors": "Sektoren",
  "update": {
    "title": "Benutzer bearbeiten",
    "confirm": {
      "title": "Benutzer bearbeiten"
    }
  },
  "confirm": {
    "message": "Bestätigen Sie den Abbruch des Vorgangs? Alle nicht gespeicherten Daten gehen verloren."
  },
  "filters": {
    "selectionQuickFilters": {
      "allUsers": "Alle Benutzer",
      "selectedUsers": "Ausgewählte Benutzer",
      "unselectedUsers": "Nicht ausgewählte Benutzer"
    }
  },
  "read": {
    "title": "Benutzer anzeigen"
  }
}
